export const currentUserSelector = state => state.user;
export const currentOrderSelector = state => state.currentOrder;
export const newOrderSelector = state => state.newOrder;
export const allOrdersSelector = state => state.allOrders;
